import { VIEW_PLANS_CTA_SELECTED } from 'app/features/landing/viewPlansCta/actionTypes';
import { commonActionDetail } from 'app/analytics/selectors';
import { ActionDetail } from 'app/analytics/helpers';

const viewPlansCta = {
  [VIEW_PLANS_CTA_SELECTED]: (getState, { payload: { ...rest } }) => ({
    type: 'track',
    name: 'Upsell Selected',
    properties: ActionDetail({
      ...commonActionDetail(getState()),
      ...rest,
    }),
  }),
};

export default viewPlansCta;
